<template>
  <div class="clipFilter">
    <div class="clipFilter_controller">
      <div class="clipFilter_controller-info">
        <span v-if="total">全{{ total }}件</span>
        <span v-if="selectedClips.length"
          >{{ selectedClips.length }}件選択</span
        >
      </div>
      <div class="clipFilter_controller-container">
        <slot name="start" />
        <div v-if="clipToolsOpen" class="clipFilter_tools">
          <!--          <v-btn-->
          <!--            v-if="!options.hideMove"-->
          <!--            x-small-->
          <!--            :class="{ ['clipFilter_tools-disabled']: !selectedClips.length }"-->
          <!--            :color="'text'"-->
          <!--            @click="$emit('onMove')"-->
          <!--          >-->
          <!--            <span class="icon icon-move" />-->
          <!--            <div class="clipFilter_text">移動する</div>-->
          <!--          </v-btn>-->
          <v-btn
            v-if="!options.hideCreate"
            x-small
            :class="{ ['clipFilter_tools-disabled']: !selectedClips.length }"
            :color="'text'"
            @click="$emit('onCreate')"
          >
            <span class="icon icon-folder" />
            <div class="clipFilter_text">フォルダ作成</div>
          </v-btn>
          <v-btn
            v-if="!options.hideDownload"
            x-small
            :class="{ ['clipFilter_tools-disabled']: !selectedClips.length }"
            :color="'text'"
            @click="$emit('onDownload')"
          >
            <span class="icon icon-download" />
            <div class="clipFilter_text">ダウンロード</div>
          </v-btn>
          <v-btn
            v-if="!options.hideDelete"
            x-small
            :class="{ ['clipFilter_tools-disabled']: !selectedClips.length }"
            :color="'text'"
            @click="$emit('onDelete')"
          >
            <span class="icon icon-trash" />
            <div class="clipFilter_text">削除</div>
          </v-btn>
        </div>
        <v-btn
          class="clipFilter_filter-btn"
          x-small
          :color="clipToolsOpen ? 'lightBlue' : ''"
          @click="clipToolsClick"
        >
          <span v-if="!clipToolsOpen" color="primary">選択する</span>
          <span v-if="clipToolsOpen" color="primary">キャンセル</span>
        </v-btn>
        <v-btn
          v-if="!options.hideSearch"
          class="clipFilter_filter-btn"
          x-small
          :color="isSearchTriggered ? 'lightBlue' : ''"
          @click="filterOpen = !filterOpen"
        >
          <v-icon
            v-if="isSearchTriggered"
            small
            @click.stop="refreshSelectedToggles"
          >
            mdi-close
          </v-icon>
          <div class="clipFilter_text">
            絞りこみ{{
              isSearchTriggered
                ? '：' + (videoClips ? totalFiltered : 0) + '件'
                : ''
            }}
          </div>
          <span
            color="primary"
            class="icon icon-chevron-down"
            :class="{ 'clipFilter_chevron-open': filterOpen }"
          />
        </v-btn>
      </div>
    </div>
    <div v-if="filterOpen && !options.hideSearch">
      <div class="clipFilter_cat clipFilter_cat-daterange">
        <v-checkbox v-model="hasDate" />
        <DateRangePicker
          :dates="dates"
          :active="hasDate"
          @applySetDates="applySetDates($event)"
        />
      </div>

      <div class="clipFilter_cams">
        <template v-for="(event, index) in currentGroupCamList">
          <v-btn
            :key="index"
            class="clipFilter_btn"
            depressed
            x-small
            :color="selectedCam.includes(event.id) ? 'lightBlue' : ''"
            :outlined="!selectedCam.includes(event.id)"
            @click="toggleCamSearch(event.id)"
          >
            {{ currentGroupCamList[index].name }}
          </v-btn>
        </template>
      </div>

      <div class="clipFilter_events">
        <template v-for="(event, index) in searchKeys">
          <v-btn
            :key="index"
            class="clipFilter_btn"
            depressed
            x-small
            :color="selectedEventSearch[index] ? 'lightBlue' : ''"
            :outlined="!selectedEventSearch[index]"
            @click="toggleEventSearchKey(index)"
          >
            {{ searchKeys[index].value }}
          </v-btn>
        </template>
      </div>
      <section class="clipFilter_actions">
        <v-btn
          class="clipFilter_search-btn"
          x-small
          :disabled="!isSearchActive"
          @click="handleSearch()"
        >
          検索</v-btn
        >
      </section>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapActions, mapGetters, mapState } from 'vuex';
import DateRangePicker from '@/components/inputs/DateRangePicker.vue';
import { getDefaultRangeCalendar } from '@/utils/date';
const customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);

export default {
  name: 'ClipFilter',
  components: {
    DateRangePicker,
  },
  props: {
    selectedClips: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => ({
        hideSearch: false,
        hideCreate: false,
        hideMove: false,
        hideDelete: false,
        hideDownload: false,
      }),
    },
    total: {
      type: Number,
      default: 0,
    },
    totalFiltered: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    dialog: false,
    dialogDelete: false,
    hasDate: false,
    dates: getDefaultRangeCalendar(),
    filterOpen: false,
    selectedEventSearch: {},
    selectedCam: [],
    clipToolsOpen: false,
    isSearchTriggered: false,
  }),

  computed: {
    ...mapGetters('common', {
      searchKeys: 'getSearchKeys',
      currentGroupCamList: 'currentGroupCamList',
    }),
    ...mapState({
      videoClips: (state) => state.video.videoClips,
      cameraList: (state) => state.common.cameraList,
    }),
    isSearchActive() {
      return [
        this.hasDate,
        this.selectedCam.length,
        Object.keys(this.selectedEventSearch).some(
          (key) => this.selectedEventSearch[key]
        ),
      ].some((val) => val);
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dates: {
      handler() {
        this.hasDate = true;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('video', ['setSearchParams']),
    refreshSelectedToggles() {
      this.selectedCam = [];
      this.selectedEventSearch = {};
      this.hasDate = false;
      this.handleSearch();
      this.isSearchTriggered = false;
    },
    clipToolsClick() {
      this.clipToolsOpen = !this.clipToolsOpen;
      this.$emit('clipToolsOpenChange', this.clipToolsOpen);
      this.$emit('refreshSelectedClips');
    },
    getFilterParams() {
      const filterParams = {};
      const selectedEventSearchKeys = Object.keys(this.selectedEventSearch)
        .filter((key) => this.selectedEventSearch[key])
        .map((key) => this.searchKeys[key].value);
      if (selectedEventSearchKeys.length > 0) {
        filterParams.eventSearchKeys = selectedEventSearchKeys
          .map((event) => `content|${event}`)
          .join(',');
        filterParams.__isFiltered = true;
      }
      if (this.selectedCam.length) {
        filterParams.cameraIds = this.selectedCam.join(',');
        filterParams.__isFiltered = true;
      }
      if (this.hasDate) {
        filterParams.startDate = this.dates[0];
        filterParams.endDate = this.dates[1];
        filterParams.__isFiltered = true;
      }

      return filterParams;
    },
    handleSearch(noSearchTrigger = false) {
      if (!noSearchTrigger) {
        this.isSearchTriggered = true;
      }
      this.setSearchParams({});
      this.$emit('search', this.getFilterParams());
      this.$emit('refreshSelectedClips');
    },
    toggleEventSearchKey(index) {
      this.$set(
        this.selectedEventSearch,
        index,
        !this.selectedEventSearch[index]
      );
    },
    toggleCamSearch(id) {
      const index = this.selectedCam.findIndex((cameraId) => cameraId === id);
      if (index > -1) {
        this.selectedCam.splice(index, 1);
      } else {
        this.selectedCam.push(id);
      }
    },
    applySetDates(event = []) {
      if (event.length) {
        this.dates = event;
      }
    },
  },
};
</script>

<style lang="scss">
.clipFilter {
  &_actions {
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
  }
  &_search-btn {
    &.v-btn {
      width: 122px;
      height: 25px !important;
      border-radius: 5px;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
      background-color: #0075c2 !important;
      font-size: 10px !important;
      font-weight: bold !important;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #fff !important;
      &.v-btn--disabled {
        background-color: #eee !important;
        color: #ccc !important;
        box-shadow: none;
      }
    }
  }
  &_chevron {
    &-open {
      transform: rotate(180deg);
    }
  }
  & .dateRangePicker_dates {
    width: unset;
    flex-wrap: nowrap;
    & .dateRangePicker_separator {
      margin-right: 10px;
    }
  }

  &_controller {
    margin: 20px 0;
    display: flex;
    align-items: center;
    &-info {
      flex: 1;
      justify-content: space-between;
      font-size: 14px;
      font-weight: normal;
      line-height: 0.93;
      letter-spacing: normal;
      text-align: left;
      color: #989898;
      :first-child {
        margin-right: 10px;
      }
    }
    &-container {
      display: flex;
      justify-content: space-between;
    }
  }
  &_btn {
    margin-right: 5px;
  }
  &_cams {
    border-top: 1px solid #eee;
    padding-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &_events {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  &_cat {
    border-top: 1px solid #eee;
    padding-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    &-daterange {
      flex-wrap: nowrap;
      .v-input--checkbox {
        margin-top: 0;
        padding-top: 10px;
        .v-messages {
          display: none;
        }
        .v-input__slot {
          margin-bottom: 0;
        }
      }
    }
  }
  &_icon {
    margin-right: 5px;
  }
  &_filter-btn {
    &.v-btn {
      margin-top: 10px;
      &:not(.v-btn--round).v-size--x-small {
        padding-left: 8px;
        padding-right: 8px;
        font-size: 12px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.08;
        letter-spacing: normal;
        text-align: right;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
        &.v-btn--outlined {
          padding-left: 7px;
          padding-right: 7px;
          color: #989898;
          border-color: #989898;
        }
      }
      &:not(:last-child) {
        margin-right: 8px;
      }
    }
    .icon {
      margin-left: 5px;
    }
  }
  &_tools {
    margin-right: 8px;
    &-disabled {
      color: #ccc !important;
      background-color: #eeeeee !important;
      pointer-events: none;
      &.v-btn:not(.v-btn--round).v-size--x-small {
        box-shadow: none;
      }
    }
    .v-btn {
      &:not(.v-btn--round).v-size--x-small {
        font-size: 10px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: left;
        color: #0075c2;
      }
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
      .icon {
        margin-right: 5px;
        font-size: 16px;
      }
    }
  }
}
</style>
